import './style.scss';
import React, {  useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';

import moment from 'moment';

import { Text } from '../../atoms';


import { getMenuData } from '../../../services/api';

import { updateConfigHeaderFooter } from '../../../actions';
import { Button } from '../../atoms';

import { FaLink, FaExclamationTriangle } from 'react-icons/fa';


const Acronym = (props) => {
    const {
        loginInfo: { loginWithoutAcronymLimit, useCompanyAcronymOnDomain, usingAcronymOnLogin, acronym, domain },
    } = getMenuData();
    
    const history = useHistory();
    const searchParams = new URLSearchParams(history.location.search);
    const pathname = searchParams.get('pathname') || '/';
    
    const { updateConfigHeaderFooter } = props;

    useEffect(() => {

        const acronymInactive = useCompanyAcronymOnDomain === 0 || usingAcronymOnLogin || !acronym;

        if (acronymInactive) {
            history.push(pathname);
        }

        updateConfigHeaderFooter({ headerStyle: 'hide', footerStyle: 'hide' });
    }, []);

   

    
    async function continuar() {
        sessionStorage.setItem('ACRONYM', JSON.stringify({ "status": true })); 
        history.push(pathname);
    }


    const companyAcronymOnDomainFormat = moment.utc(loginWithoutAcronymLimit).format('DD/MM/YYYY');
    const domainURL = 'https://' + domain + '/';

   
    return (
        <>
            <div className="acronym-container">
                <div className="acronym-wrapper">
                    <div className="acronym-logo">
                        <FaLink />
                    </div>

                    <Text component="h2" text={'Atenção: o endereço da plataforma está mudando!'} />

                    <div className={'acronym-info'}>
                        <Text component="p" text={'A partir de agora, o acesso será feito por um novo link:'} />
                        <a href={domainURL} target="_blank" rel="noopener noreferrer">
                            {domainURL}
                        </a>

                        <Text
                            component="p"
                            text={
                                '<b>Não se preocupe:</b> todos os seus conteúdos, cursos e informações continuarão disponíveis normalmente.'
                            }
                        />
                        <div className="address">
                            <FaExclamationTriangle />
                            <Text
                                component="p"
                                text={`O endereço antigo ficará disponível até ${companyAcronymOnDomainFormat}.`}
                            />
                        </div>
                        <Text
                            component="p"
                            text={`Para facilitar seu acesso, recomendamos que atualize agora mesmo seus favoritos e atalhos.`}
                        />
                    </div>

                    <div className={'btnContainer'}>
                        <Button className={`button02`} text="Entendi" callEvent={() => continuar()} />
                    </div>
                </div>
            </div>
        </>
    );
};

const mapDispatchToProps = (dispatch) => ({
    updateConfigHeaderFooter: (item) => dispatch(updateConfigHeaderFooter(item)),
});

export default compose(withRouter, connect(null, mapDispatchToProps))(Acronym);
